"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.CircleSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('circle'),
    center: XYPosition_1.XYPositionSchema,
    radius: zod_1.z.number(),
    filled: zod_1.z.coerce.boolean().optional(),
    width: zod_1.z.number().optional(),
});
//# sourceMappingURL=Circle.js.map